export const MOCKED_AI_THUMBNAIL_PROMPT = [
  {
    name: '업무',
    text: `장화 신은 고양이처럼 생긴 황토색 고양이가 들어간 그림을 그려줘.조건은 아래와 같아.
- 16:9 비율의 이미지
- 배경은 블러 처리된 깔끔한 배경
- 책상 위에 노트북이 있고, 옆에 문서들이 쌓여있어.
- 고양이가 노트북을 바라보고 있어.
- 고양이는 안경과 빨간 스웨터를 입었어
Draw a picture of a clay-colored cat that looks like Puss in Boots. The conditions are as follows:
- 16:9 aspect ratio image
- A clean background with a blur effect
- A laptop on a desk with stacks of documents beside it
- The cat is looking at the laptop
- The cat is wearing glasses and a red sweater`,
    icon: 'smile_face',
  },
  {
    name: '하이파이브',
    text: `장화 신은 고양이처럼 생긴 황토색 고양이 2마리가 있는 그림을 그려줘.조건은 아래와 같아.
- 16:9 비율의 이미지
- 배경은 블러 처리된 깔끔한 배경
- 서로를 보면서 하이파이브 하고 있어.
- 한 마리는 안경을 쓰고 있고, 두마리 모두 스웨터를 입고있는데 다른 색상이야.
Draw a picture of two clay-colored cats that look like Puss in Boots. The conditions are as follows:
- 16:9 aspect ratio image
- A clean background with a blur effect
- They are high-fiving each other while looking at each other
- One cat is wearing glasses, and both cats are wearing sweaters of different colors`,
    icon: 'celebration',
  },
  {
    name: '꿀팁',
    text: `장화 신은 고양이처럼 생긴 황토색 고양이가 들어간 그림을 그려줘.조건은 아래와 같아.
- 16:9 비율의 이미지
- 배경은 블러 처리된 깔끔한 배경
- 고양이는 안경과 빨간 스웨터를 입었어
- 고양이가 통통한 꿀통을 안고 바라보고 있어.
- 손으로 찍어서 먹고 있는 것도 추가해줘.
Draw a picture of a clay-colored cat that looks like Puss in Boots. The conditions are as follows:
- 16:9 aspect ratio image
- A clean background with a blur effect
- The cat is wearing glasses and a red sweater
- The cat is hugging and looking at a chubby honey pot
- Add the cat dipping its paw into the honey and eating it`,
    icon: 'honey',
  },
  {
    name: '커피',
    text: `장화 신은 고양이처럼 생긴 황토색 고양이가 들어간 그림을 그려줘.조건은 아래와 같아.
- 16:9 비율의 이미지
- 배경은 블러 처리된 깔끔한 배경
- 시간은 밤이고, 스탠드 조명만 켜진 느낌이면 좋겠어.
- 책상 위에 노트북이 있고, 옆에 문서과 이미 마신 커피 컵들이 10개 정도 쌓여있어.
- 고양이가 노트북을 바라보면서 커피를 마시고 있어.
- 고양이는 안경과 빨간 스웨터를 입었어
Draw a picture of a clay-colored cat that looks like Puss in Boots. The conditions are as follows:
- 16:9 aspect ratio image
- A clean background with a blur effect
- It's nighttime, with only a desk lamp providing light
- A laptop on the desk, with documents and about 10 empty coffee cups stacked beside it
- The cat is looking at the laptop while drinking coffee
- The cat is wearing glasses and a red sweater`,
    icon: 'coffee',
  },
  {
    name: '지식',
    text: `장화 신은 고양이처럼 생긴 황토색 고양이가 들어간 그림을 그려줘.조건은 아래와 같아.
- 16:9 비율의 이미지
- 배경은 블러 처리된 깔끔한 배경
- 고양이는 안경과 빨간 스웨터를 입었어
- 머리 위에 전구가 떠있고, 놀란 얼굴을 표현해줘
Draw a picture of a clay-colored cat that looks like Puss in Boots. The conditions are as follows:
- 16:9 aspect ratio image
- A clean background with a blur effect
- The cat is wearing glasses and a red sweater
- A light bulb is floating above its head, and the cat has a surprised expression`,
    icon: 'sprout',
  },
];
